export function numericalStat(value: number, unit = "") {
  return value === 0 ? `–` : `${value}${unit}`;
}
